import Patch from '@services/MonkeyPatching';
import Vue from 'vue';
import './plugins';
import App from '@views/App.vue';
import store from '@stores';
import router from '@routes';
import vuetify from './plugins/vuetify';
import '@mixins/mixin';
import '@services';
import '@bus/Bus';
import { WeatherAPI } from '@models/Weather';
import './registerServiceWorker';
window.WeatherAPI = WeatherAPI;
Vue.config.productionTip = false;

const app = new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App),
  data: {
    isOnline: navigator.onLine === true,
  },
  methods: {
    async updateOnlineStatus(e) {
      const { type } = e;
      this.isOnline = type === 'online';
      if (!this.isOnline) {
        $bus.$emit('offline');
        this.$store.commit('auth/setOnLineStatus', false);
      } else {
        $bus.$emit('online');
        this.$store.commit('auth/setOnLineStatus', true);

        if (!localStorage.getItem('x-access-token')) {
          $showSuccess('You are online!');
        } else {
          try {
            await store.dispatch('auth/fetchUser');
          } catch (e) {
            $showSuccess('You are online!');
          }
        }
      }
    },
  },
  mounted() {
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);

    if (this.isOnline) {
      this.$store.commit('auth/setOnLineStatus', true);
    }

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready
        .then((registration) => {
          navigator.serviceWorker.addEventListener('message', (event) => {
            if (event.data === 'RoutesCached') {
              $showSuccess('Routes cached for offline use!');
            }
          });
        })
        .catch((error) => {
          console.error('Service worker registration failed:', error);
        });
    }
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  },
}).$mount('#app');

Patch.patchWindowObject(app);
